module.exports = __webpack_public_path__ + "static/media/wolf-head.4e7bf362.svg";